module.exports = __webpack_public_path__ + "img/logo_long.17a37451.png";